// ✅ Updated Thevvatap.jsx (with i18n)
// - Fixes "t is not defined" by adding useTranslation()
// - All UI strings moved to t("thevvatap....")
// - Server values remain SAME: thevtype values (regular/thev1/thev2/thev3) and status "Paid"
// NOTE: Keep your logic as-is, only strings replaced

import React, { useEffect, useRef, useState } from 'react'
import './Thevvatap.css'
import { ToastContainer, toast } from 'react-toastify';
import back from "../../imgs/backexam.png";
import close from "../../imgs/close.png";
import { Co2Sharp, Face6TwoTone, FaxTwoTone } from '@mui/icons-material';
import axios from 'axios';
import { Document, Page, Text, View, StyleSheet, PDFViewer } from '@react-pdf/renderer';
import Billprint from '../Billprint/Billprint';
import { useNavigate } from 'react-router-dom';
import { UilEditAlt, UilTrash, UilSetting } from '@iconscout/react-unicons'
import { transliterate } from 'transliteration';
import * as XLSX from 'xlsx';
import { useTranslation } from "react-i18next";

const Thevvatap = (props) => {
  const { t } = useTranslation();

  const [input, setInput] = useState({ date1: "", date2: "", thevtype: "select", thevdesign: "1" });
  const inputRefs = useRef([]);
  const notify = (msg) => toast(msg);
  const notifyerror = (msg) => toast.error(msg);
  const [DataSource, setDataSource] = useState([]);
  const [DataSource2, setDataSource2] = useState([]);
  const refdelete = useRef(null);
  const refdeleteclose = useRef(null);
  const refthevtype = useRef(null);
  const refthevtypeclose = useRef(null);
  const [wait, setWait] = useState(false);
  const [waitvatap, setWaitvatap] = useState(false);
  const [lastdate1, setLastdate1] = useState("");
  const [lastdate2, setLastdate2] = useState("");
  const currentDate = new Date();

  const handleChange = async (event) => {
    const name = event.target.name;
    let valuecurrent = "";
    valuecurrent = event.target.value;
    setInput(value => ({ ...value, [name]: valuecurrent }));
  }

  const handlethevtype = () => refthevtype.current.click();
  const handlethevtypeclose = () => refthevtypeclose.current.click();
  const handledeleteclose = () => refdeleteclose.current.click();

  useEffect(() => { getmaxno(); }, [])

  useEffect(() => {
    if (input.thevtype !== "select") getthevmaxdate();
  }, [input.thevtype])

  const exportToExcel = () => {
    const wb = XLSX.utils.table_to_book(document.getElementById('myTableexcel'), { sheet: "Sheet JS" });
    const ws = wb.Sheets["Sheet JS"];

    ws['!cols'] = [
      { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 8 }, { wch: 40 },
      { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 },
    ];

    const range = XLSX.utils.decode_range(ws['!ref']);

    for (let R = range.s.r; R <= range.e.r; ++R) {
      const cell = ws[XLSX.utils.encode_cell({ r: R, c: 9 })];
      if (cell && typeof cell.v === 'string') cell.v = cell.v.replace(/\//g, '-');
    }

    for (let R = range.s.r; R <= range.e.r; ++R) {
      const cell = ws[XLSX.utils.encode_cell({ r: R, c: 5 })];
      if (cell) {
        let cellValue = cell.v.toString();
        if (!cellValue.startsWith('A')) cell.v = `'A${cellValue}`;
        cell.t = 's';
      }
    }

    for (let R = range.s.r; R <= range.e.r; ++R) {
      const cell = ws[XLSX.utils.encode_cell({ r: R, c: 2 })];
      if (cell) { cell.v = cell.v.toString(); cell.t = 's'; }
    }

    for (let C = 0; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      if (ws[cellAddress]) {
        ws[cellAddress].s = ws[cellAddress].s || {};
        ws[cellAddress].s.fill = { patternType: "solid", fgColor: { rgb: "ADD8E6" } };
        ws[cellAddress].s.font = { bold: true };
      }
    }

    XLSX.writeFile(wb, t("thevvatap.excel.fileName"));
  };

  async function getmaxno() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    axios.post('https://excellentdairy.com/dairy/php/cust/getmaxno2.php',
      { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }
    ).then(function sample(response) {
      if (response.data) {
        setInput(prevInput => ({
          ...prevInput,
          date1: response.data[0].maxdate1,
          date2: response.data[0].maxdate2
        }));
      }
    }).catch(err => console.log(err));
  }

  const handleDelete = () => refdelete.current.click();

  const getthevmaxdate = () => {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    let rawData = {
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
      thevtype: input.thevtype
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://excellentdairy.com/dairy/php/cust/getthevmaxdate.php', formData, {
      'Content-Type': 'multipart/form-data',
    }).then(function sample(response) {
      if (response.data && response.data.length > 0) setDataSource2(response.data);
      else setDataSource2([]);
    }).catch(err => console.log(err));
  }

  const deletevatap = () => {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    let rawData = {
      mainuser: localStorage.getItem("contact"),
      bill10type: localStorage.getItem("bill10type"),
      thevtype: input.thevtype,
      date: DataSource2[0].thevvatapdate,
      date1: DataSource2[0].date1,
      date2: DataSource2[0].date2,
      mainuser2: mainuser2,
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://excellentdairy.com/dairy/php/cust/deletevatap2.php', formData, {
      'Content-Type': 'multipart/form-data',
    }).then(function sample(response) {
      if (response.data && response.data === "Deleted") {
        notify(t("thevvatap.toast.vatapDeleted"));
        setDataSource2([]);
        getthevmaxdate();
        handledeleteclose();
      }
    }).catch(err => console.log(err));
  }

  const showprint = () => {
    if (DataSource && DataSource.length > 0) {
      localStorage.setItem("date1print", input.date1);
      localStorage.setItem("date2print", input.date2);
      localStorage.setItem("thevtype", input.thevtype);
      localStorage.setItem("printdesign", input.thevdesign);
      localStorage.setItem("records", input.thevdesign === "1" ? "31" : '5');
      window.open("/thevvatapprint", '_blank');
    } else {
      notifyerror(t("thevvatap.toast.noBillForPeriod"));
    }
  }

  useEffect(() => {
    const currentDate1 = new Date(input.date1);
    const dayOfMonth1 = currentDate1.getDate();
    const currentMonth1 = currentDate1.getMonth();
    const currentYear1 = currentDate1.getFullYear();

    let lastDayOfMonth1;
    if (dayOfMonth1 >= 1 && dayOfMonth1 <= 10) lastDayOfMonth1 = 10;
    else if (dayOfMonth1 >= 11 && dayOfMonth1 <= 20) lastDayOfMonth1 = 20;
    else if (dayOfMonth1 >= 21 && dayOfMonth1 <= 30) lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate();

    if (lastDayOfMonth1 !== undefined) {
      const formattedDate2 = new Date(currentYear1, currentMonth1, lastDayOfMonth1).toLocaleDateString('en-CA');
      setInput(prevInput => ({ ...prevInput, date2: formattedDate2 }));
    }
  }, [input.date1]);

  // Minimal MySQL-safe string escape
  const escapeMySQL = (v) =>
    String(v ?? '').replace(/[\0\n\r\b\t\\'"\x1a]/g, (c) => ({
      '\0': '\\0', '\n': '\\n', '\r': '\\r', '\b': '\\b',
      '\t': '\\t', '\\': '\\\\', "'": "\\'", '"': '\\"', '\x1a': '\\Z'
    }[c]));

  const isValidYmd = (s) =>
    typeof s === 'string' &&
    /^\d{4}-\d{2}-\d{2}$/.test(s.trim()) &&
    s !== '0000-00-00';

  function Updatethev(newStatus = 'Paid') {
    const mainuser = localStorage.getItem('contact') || '';
    if (!mainuser) return '';

    const todayYmd = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit'
    }).format(new Date());

    const rows = (DataSource || []).filter(
      (u) => !isNaN(parseFloat(u.thevamt)) &&
        parseFloat(u.thevamt) > 0 &&
        isValidYmd(u?.lastdate)
    );
    if (rows.length === 0) return '';

    const seen = new Set();
    const tupleList = rows.map((u) => {
      const kno = String(u.kno ?? '').trim();
      const date2 = String(u.lastdate).trim();
      const key = `${kno}|${date2}`;
      if (!kno || !isValidYmd(date2) || seen.has(key)) return null;
      seen.add(key);
      return `('${escapeMySQL(kno)}','${escapeMySQL(date2)}')`;
    }).filter(Boolean).join(',');

    if (!tupleList) return '';

    let sql = "";
    if (input.thevtype === "regular") {
      sql = `UPDATE bill
        SET thevstatus='${escapeMySQL(String(newStatus))}',
            vatapdate='${escapeMySQL(todayYmd)}'
        WHERE mainuser='${escapeMySQL(mainuser)}'
          AND (kno, date2) IN (${tupleList});`;
      thevvatap(sql);
    } else if (input.thevtype === "thev1") {
      sql = `UPDATE bill
        SET thevstatus1='${escapeMySQL(String(newStatus))}',
            vatapdate1='${escapeMySQL(todayYmd)}'
        WHERE mainuser='${escapeMySQL(mainuser)}'
          AND (kno, date2) IN (${tupleList});`;
      thevvatap(sql);
    } else if (input.thevtype === "thev2") {
      sql = `UPDATE bill
        SET thevstatus2='${escapeMySQL(String(newStatus))}',
            vatapdate2='${escapeMySQL(todayYmd)}'
        WHERE mainuser='${escapeMySQL(mainuser)}'
          AND (kno, date2) IN (${tupleList});`;
      thevvatap(sql);
    } else if (input.thevtype === "thev3") {
      sql = `UPDATE bill
        SET thevstatus3='${escapeMySQL(String(newStatus))}',
            vatapdate3='${escapeMySQL(todayYmd)}'
        WHERE mainuser='${escapeMySQL(mainuser)}'
          AND (kno, date2) IN (${tupleList});`;
      thevvatap(sql);
    } else {
      notifyerror(t("thevvatap.toast.selectType"));
    }
    return sql;
  }

  async function thevvatap(sql) {
    setWaitvatap(true);
    var mainuser2 = jsEncode.encode("mamapr", 125);

    if (DataSource && DataSource.length > 0) {
      let rawData = {
        date1: input.date1,
        date2: input.date2,
        thevtype: input.thevtype,
        sql: sql,
        bill10type: localStorage.getItem("bill10type"),
        mainuser: localStorage.getItem("contact"),
        mainuser2: mainuser2,
      }
      rawData = JSON.stringify(rawData)
      let formData = new FormData()
      formData.append('data', rawData)

      axios.post('https://excellentdairy.com/dairy/php/cust/thevvatap3.php', formData, {
        'Content-Type': 'multipart/form-data',
      }).then(function sample(response) {
        if (response.data.trim() === "Updated.") {
          notify(t("thevvatap.toast.vatapDone"));
          getthevmaxdate();
          setWaitvatap(false);
        }
      }).catch(err => {
        console.log(err);
        setWaitvatap(false);
      });
    } else {
      notifyerror(t("thevvatap.toast.selectBillDate"));
      setWaitvatap(false);
    }
  }

  const getthevreport = () => {
    setWait(true);
    var mainuser2 = jsEncode.encode("mamapr", 125);

    let rawData = {
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
      thevtype: input.thevtype,
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://excellentdairy.com/dairy/php/cust/getthevregister2.php', formData, {
      'Content-Type': 'multipart/form-data',
    }).then(function sample(response) {
      if (response.data && response.data.length > 0) {
        setDataSource(response.data);
        setWait(false);
      } else {
        notifyerror(t("thevvatap.toast.noData"));
        setDataSource([]);
        setWait(false);
      }
    }).catch(err => {
      console.log(err);
      setWait(false);
    });
  }

  function formatDate(inputDate) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(inputDate).toLocaleDateString(undefined, options);
  }

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    }
  };

  const toAmt = (v) => {
    if (typeof v === 'number') return Number.isFinite(v) ? v : 0;
    const n = Number(String(v ?? '').replace(/[^\d.-]/g, ''));
    return Number.isFinite(n) ? n : 0;
  };

  const getThevTypeLabel = (v) => {
    if (v === "regular") return t("thevvatap.type.regular");
    if (v === "thev1") return localStorage.getItem("itr1name") || t("thevvatap.type.thev1");
    if (v === "thev2") return localStorage.getItem("itr2name") || t("thevvatap.type.thev2");
    if (v === "thev3") return localStorage.getItem("itr3name") || t("thevvatap.type.thev3");
    return "";
  };

  return (
    <>
      <button type="button" className="btn btn-primary" data-bs-toggle="modal" hidden={true} ref={refdelete} data-bs-target="#deletethev" />

      <div className="modal fade" id="deletethev" tabIndex="-1" role="dialog" aria-hidden="true" >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title"></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refdeleteclose} aria-label="Close" />
            </div>
            <div className="modal-body">
              <h4 className="modal-title">{t("thevvatap.modal.delete.title")}</h4>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handledeleteclose}>
                {t("thevvatap.btn.no")}
              </button>
              <button type="button" className="btn btn-danger" onClick={deletevatap}>
                {t("thevvatap.btn.yes")}
              </button>
            </div>
          </div>
        </div>
      </div>

      <button type="button" className="btn btn-primary" data-bs-toggle="modal" hidden={true} ref={refthevtype} data-bs-target="#thevtype" />

      <div className="modal fade" id="thevtype" tabIndex="-1" role="dialog" aria-hidden="true" >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title"></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refthevtypeclose} aria-label="Close" />
            </div>
            <div className="modal-body">
              <h4 className="modal-title">{t("thevvatap.modal.design.title")}</h4>

              <div className="mb-2">
                <span className='subheadsank'>{t("thevvatap.modal.design.label")}</span>
                <select value={input.thevdesign} name='thevdesign' id='thevdesign' onChange={handleChange} className={"form-control"}>
                  <option value="1">{t("thevvatap.design.combined")}</option>
                  <option value="2">{t("thevvatap.design.memberWise")}</option>
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handlethevtypeclose}>
                {t("thevvatap.btn.no")}
              </button>
              <button type="button" className="btn btn-danger" onClick={showprint}>
                {t("thevvatap.btn.yes")}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="sanklanmain">
        <div className="firstrowsank">
          <img onClick={props.visibility} className='back' src={back} alt="" />
          <div className="colmainbill">
            <div className="firstrowbill">
              <div className="rowbill">

                <div className="mb-2">
                  <span className='subheadsank'>{t("thevvatap.label.type")}</span>
                  <select value={input.thevtype} name='thevtype' id='thevtype' onChange={handleChange} className={"form-control"}>
                    <option value="select">{t("thevvatap.selectType")}</option>
                    <option value="regular">{t("thevvatap.type.regular")}</option>
                    <option value="thev1">{localStorage.getItem("itr1name")}</option>
                    <option value="thev2">{localStorage.getItem("itr2name")}</option>
                    <option value="thev3">{localStorage.getItem("itr3name")}</option>
                  </select>
                </div>

                <div className="mb-2">
                  <span className='subheadsank'>{t("thevvatap.label.billEndFrom")}</span>
                  <input disabled type="date" className="form-control" autoComplete='off' id="date1thev" name="date1" value={input.date1} onChange={handleChange} />
                </div>

                <span className='subheadbill'>{t("thevvatap.to")}</span>

                <div className="mb-2">
                  <span className='subheadsank'>.</span>
                  <input disabled type="date" className="form-control" autoComplete='off' id="date2thev" name="date2" value={input.date2} onChange={handleChange} />
                </div>

                <div className="mb-2">
                  {wait ? (
                    <button type="submit" id='show' className="btn btn-primary mx-1 sanksmall">{t("thevvatap.btn.loading")}</button>
                  ) : (
                    <button onClick={getthevreport} type="submit" id='show' className="btn btn-primary mx-1 sanksmall">{t("thevvatap.btn.viewReport")}</button>
                  )}

                  <button onClick={handlethevtype} type="submit" id='show' className="btn btn-primary mx-1 sanksmall">{t("thevvatap.btn.print")}</button>
                  <button onClick={exportToExcel} ref={ref => (inputRefs.current[4] = ref)} type="submit" id='print' className="btn btn-primary mx-1 sanksmall">{t("thevvatap.btn.excel")}</button>

                  {waitvatap ? (
                    <button type="submit" className="btn btn-success mx-1 sanksmall">{t("thevvatap.btn.loading2")}</button>
                  ) : (
                    <button onClick={() => Updatethev("Paid")} type="submit" className="btn btn-success mx-1 sanksmall">{t("thevvatap.btn.doVatap")}</button>
                  )}
                </div>

                {input.thevtype !== "select" ? (
                  <div hidden={DataSource2.length <= 0}>
                    <div className={(DataSource2 && DataSource2.length > 0 && DataSource2[0].thevtype !== null ? "lblthev" : "")}>
                      <span className='subheadthev'>
                        {DataSource2 && DataSource2.length > 0 && DataSource2[0].thevtype !== null
                          ? `${t("thevvatap.info.type")}: ${getThevTypeLabel(DataSource2[0].thevtype)}`
                          : ""}
                      </span>
                      <span className='subheadthev'>
                        {DataSource2 && DataSource2.length > 0 && DataSource2[0].thevvatapdate !== null
                          ? `${t("thevvatap.info.lastVatap")}: ${formatDate(DataSource2[0].thevvatapdate)}`
                          : ""}
                      </span>
                      <span className='subheadthev'>
                        {DataSource2 && DataSource2.length > 0 && DataSource2[0].date1 !== null && DataSource2[0].date2 !== null
                          ? `${t("thevvatap.info.billEndRange")}: ${DataSource2[0].date1} ${t("thevvatap.to")} ${DataSource2[0].date2}`
                          : ""}
                      </span>

                      <UilTrash onClick={handleDelete} className={DataSource2 && DataSource2.length > 0 && DataSource2[0].thevvatapdate !== null ? "ic2" : "ic2none"} />
                    </div>
                  </div>
                ) : null}

              </div>
            </div>
          </div>
        </div>

        <div className="firstrow2">
          <div className="table-containerthev">
            <table id="myTablebill" className="table table-bordered">
              <thead>
                <tr>
                  <th className='thsmall' scope="col">{t("thevvatap.table.accNo")}</th>
                  <th className='thlarge' scope="col">{t("thevvatap.table.name")}</th>
                  <th className='thlarge' scope="col">{t("thevvatap.table.bankAcc")}</th>
                  <th className='thlarge' scope="col">{t("thevvatap.table.lastBill")}</th>
                  <th className='thsmall' scope="col">{t("thevvatap.table.totalThev")}</th>
                </tr>
              </thead>
              <tbody>
                {DataSource && DataSource.map((user, index) => {
                  const amt = toAmt(user.thevamt);
                  return amt > 0 ? (
                    <tr key={index}>
                      <td className='thsmall'>{user.kno}</td>
                      <td className='thsmall'>{user.cname}</td>
                      <td className='thsmall'>{user.accno}</td>
                      <td className='thsmall'>{user.lastdate}</td>
                      <td className='thsmall2'>{amt.toFixed(2)}</td>
                    </tr>
                  ) : null;
                })}
              </tbody>

              <tr style={{ backgroundColor: 'lightgray', fontWeight: 'bold' }}>
                <td className='thsmallcust'>{t("thevvatap.table.total")}</td>
                <td className='thsmallcust'>-</td>
                <td className='thsmallcust'>-</td>
                <td className='thsmallcust'>-</td>
                <td className='thsmallcust'>
                  {((DataSource || []).reduce((total, user) => total + toAmt(user?.thevamt), 0)).toFixed(2)}
                </td>
              </tr>
            </table>
          </div>

          {/* Excel table */}
          <div hidden>
            <table id="myTableexcel" className="table table-bordered">
              <thead>
                <tr>
                  <th>PYMT_PROD_TYPE_CODE</th>
                  <th>PYMT_MODE</th>
                  <th>DEBIT_ACC_NO</th>
                  <th>BNF_NO</th>
                  <th>BNF_NAME</th>
                  <th>BENE_ACC_NO</th>
                  <th>BENE_IFSC</th>
                  <th>AMOUNT</th>
                  <th>CREDIT_NARR</th>
                  <th>PYMT_DATE</th>
                  <th>MOBILE_NUM</th>
                  <th>EMAIL_ID</th>
                  <th>REMARK</th>
                  <th>REF_NO</th>
                </tr>
              </thead>
              <tbody>
                {DataSource && DataSource.map((user, index) =>
                  <tr key={index}>
                    <td>{"PAB_VENDOR"}</td>
                    <td>{user.bankname === "ICICI BANK" ? 'FT' : "NEFT"}</td>
                    <td>{user.dairyaccno}</td>
                    <td>{user.kno}</td>
                    <td>{transliterate(user.cname)}</td>
                    <td>{"A" + user.accno}</td>
                    <td>{user.ifsc}</td>
                    <td>{user.thevamt && user.thevamt != null ? parseFloat(user.thevamt).toFixed() : 0}</td>
                    <td>{"Test Narration"}</td>
                    <td>{currentDate.toLocaleDateString()}</td>
                    <td>{"-"}</td>
                    <td>{"-"}</td>
                    <td>{"-"}</td>
                    <td>{"-"}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

        </div>
      </div>

      <ToastContainer />
    </>
  )
}

export default Thevvatap
